export default new VueRouter({
    routes: [{
        path: '/',
        name: '',
        meta: {
          title: '新闻动态_安徽省大易科技有限公司'
        },

    }]
})
